import { render, staticRenderFns } from "./SaveActions.vue?vue&type=template&id=d815a418&"
import script from "./SaveActions.vue?vue&type=script&lang=js&"
export * from "./SaveActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports